export const quantityPricePoint = (pricePoint) => pricePoint.sold_count_threshold != null;

export const soldCountThreshold = (pricePoint) => Number(String(pricePoint.sold_count_threshold ?? '').replace(/,/g, ''));

export const pricePointTriggerLabel = (pricePoint) => (
  quantityPricePoint(pricePoint)
    ? `After ${soldCountThreshold(pricePoint).toLocaleString('en-US')} tickets sold`
    : pricePoint.human_starts_at
);

export const pricePointsError = (pricePoints = [], ticketType = {}) => {
  const activePoints = pricePoints.filter((pricePoint) => !pricePoint._destroy);
  const quantityPoints = activePoints.filter(quantityPricePoint);

  if (quantityPoints.length > 0 && quantityPoints.length !== activePoints.length) {
    return 'Use either date/time or tickets sold for all price changes on this ticket, not both.';
  }

  if (quantityPoints.length > 0 && ticketType.dynamic_pricing_enabled) {
    return 'Turn off dynamic pricing to use tickets-sold price changes.';
  }

  if (quantityPoints.some((pricePoint) => !Number.isInteger(soldCountThreshold(pricePoint)) || soldCountThreshold(pricePoint) <= 0 || soldCountThreshold(pricePoint) > 2147483647)) {
    return 'Enter how many tickets sold triggers each price change.';
  }

  const thresholds = quantityPoints.map(soldCountThreshold);
  if (new Set(thresholds).size !== thresholds.length) {
    return 'Each price change must use a different number of tickets sold.';
  }

  if (activePoints.some((pricePoint) => !quantityPricePoint(pricePoint) && !pricePoint.starts_at)) {
    return 'Choose a date and time for each price change.';
  }

  if (activePoints.some((pricePoint) => !pricePoint.price_two_decimals)) {
    return 'Enter a price for each price change.';
  }

  return null;
};
